<div class="min-h-screen bg-bg-base text-text-primary">
<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 antialiased select-none">

  @if (isLoading) {
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 animate-pulse">

    <div class="lg:col-span-2 flex flex-col gap-8">

      <div class="surface-card overflow-hidden p-2">
        <div class="aspect-[16/10] bg-bg-secondary rounded-2xl"></div>
        <div class="p-3 flex gap-2">
          @for (item of [1,2,3,4,5]; track item) {
          <div class="w-16 h-16 bg-bg-secondary rounded-xl"></div>
          }
        </div>
      </div>

      <div class="surface-card p-6 md:p-8 space-y-6">
        <div class="h-7 bg-bg-secondary rounded-lg w-3/4"></div>
        <div class="flex items-center gap-2">
          <div class="w-4 h-4 bg-bg-secondary rounded"></div>
          <div class="h-4 bg-bg-secondary rounded-md w-48"></div>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 pt-2">
          @for (item of [1,2,3,4]; track item) {
          <div class="p-4 bg-surface-elevated border border-border-subtle rounded-2xl space-y-2">
            <div class="w-6 h-6 bg-bg-secondary rounded-md mx-auto"></div>
            <div class="h-3 bg-bg-secondary rounded w-12 mx-auto"></div>
          </div>
          }
        </div>
      </div>

      <div class="surface-card p-6 md:p-8 space-y-4">
        <div class="h-5 bg-bg-secondary rounded-md w-32"></div>
        <div class="space-y-2.5 pt-2">
          <div class="h-3.5 bg-bg-secondary rounded w-full"></div>
          <div class="h-3.5 bg-bg-secondary rounded w-5/6"></div>
          <div class="h-3.5 bg-bg-secondary rounded w-4/6"></div>
        </div>
      </div>

      <div class="surface-card p-6 md:p-8 space-y-5">
        <div class="h-5 bg-bg-secondary rounded-md w-40"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
          @for (item of [1,2,3,4,5,6]; track item) {
          <div class="h-10 bg-surface-elevated border border-border-subtle rounded-xl w-full"></div>
          }
        </div>
      </div>

      <div class="surface-card p-6 md:p-8 space-y-6 relative overflow-hidden">
        <div class="absolute -right-10 -top-10 w-40 h-40 bg-primary/5 rounded-full blur-3xl"></div>
        <div class="h-5 bg-bg-secondary rounded-md w-52 relative z-10"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 relative z-10">
          @for (item of [1,2,3,4]; track item) {
          <div class="h-20 bg-surface-elevated border border-border-subtle rounded-2xl"></div>
          }
        </div>
      </div>

      <div class="surface-card p-6 md:p-8 space-y-4">
        <div class="h-5 bg-bg-secondary rounded-md w-44"></div>
        <div class="h-32 bg-surface-elevated border border-dashed border-border-strong rounded-2xl"></div>
      </div>

    </div>

    <div class="lg:col-span-1">
      <div class="surface-card p-6 sticky top-24 space-y-6">
        <div class="text-center space-y-3 pb-4 border-b border-border-subtle">
          <div class="h-7 bg-bg-secondary rounded-lg w-36 mx-auto"></div>
          <div class="h-3.5 bg-bg-secondary rounded w-24 mx-auto"></div>
        </div>
        <div class="space-y-3">
          <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl"></div>
          <div class="h-11 bg-surface-elevated border border-border-subtle rounded-xl"></div>
          <div class="h-24 bg-surface-elevated border border-border-subtle rounded-xl"></div>
          <div class="h-12 bg-bg-secondary rounded-xl w-full mt-2"></div>
        </div>
        <div class="pt-4 border-t border-border-subtle flex items-center gap-3">
          <div class="w-11 h-11 bg-bg-secondary rounded-full shrink-0"></div>
          <div class="space-y-2 w-full">
            <div class="h-3.5 bg-bg-secondary rounded w-24"></div>
            <div class="h-3 bg-bg-secondary rounded w-16"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
  }

  @if (!isLoading && errorMessage) {
  <div class="flex items-center justify-center min-h-[65vh] px-4">
    <div
      class="w-full max-w-md surface-card p-8 text-center relative overflow-hidden group">
      <div class="absolute -top-24 -right-24 w-48 h-48 bg-danger/10 rounded-full blur-3xl"></div>
      <div
        class="relative mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-danger/10 border border-danger/20 text-danger shadow-sm">
        <i class="fa-solid fa-triangle-exclamation text-xl"></i>
      </div>
      <h2 class="relative text-lg font-black text-text-primary tracking-tight">عذرًا، حدث خطأ في النظام</h2>
      <p class="relative mt-1.5 text-xs font-medium text-text-secondary">حدثت مشكلة أثناء تحميل تفاصيل هذه الوحدة.</p>

      <div
        class="relative mt-4 rounded-2xl bg-surface-elevated border border-border-strong px-4 py-3 text-xs font-mono font-bold text-text-muted text-center break-words shadow-inner">
        {{ errorMessage }}
      </div>

      <button (click)="router.navigate(['/buy'])"
        class="relative mt-6 btn btn-primary w-full py-3.5 uppercase tracking-widest text-xs">
        العودة إلى قائمة الوحدات
      </button>
    </div>
  </div>
  }

  @if (!isLoading && !errorMessage) {
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">

    <div class="lg:col-span-2 flex flex-col gap-8">

      <div class="surface-card overflow-hidden transition-all duration-300">
        <app-unit-gallery [images]="galleryImages" [title]="displayTitle" [currentIndex]="currentImageIndex"
          [verified]="propertyData.verified" [managed]="unitData?.ownerType === 'owner_portal'"
          (imageClick)="openImageModal()" (indexChange)="currentImageIndex = $event">
        </app-unit-gallery>
      </div>

      <app-property-details [propertyData]="propertyData">
      </app-property-details>

      <app-description [description]="propertyData.description">
      </app-description>

      <app-features [features]="propertyData.features" [title]="propertyData.specs.property_type || 'Unit'">
      </app-features>

      <app-compound-features [compoundFeatures]="propertyData.compound_features"
        [compoundName]="propertyData.specs.compound">
      </app-compound-features>

      <app-payment-plans [plans]="propertyData.payment_plans" [selectedPlan]="propertyData.selected_plan_summary"
        (planSelected)="onPaymentPlanSelected($event)">
      </app-payment-plans>

      <app-investment-analysis [analysis]="propertyData.price_investment_analysis" [summary]="analysisSummary"
        [lastUpdated]="analysisLastUpdated">
      </app-investment-analysis>

      <app-documents-taxes [documents]="propertyData.documents" [taxesAndFees]="propertyData.taxes_and_fees">
      </app-documents-taxes>

      <app-nearby-places [places]="propertyData.nearby_places">
      </app-nearby-places>

      <div class="surface-card overflow-hidden">
        <app-location-map [latitude]="mapLatitude" [longitude]="mapLongitude" [propertyName]="propertyData.title"
          [propertyImage]="propertyData.main_image" [locationAddress]="propertyData.location.full"
          [locationArea]="propertyData.location.area" [locationCity]="propertyData.location.city"
          [nearbyLandmarks]="mapNearbyLandmarks">
        </app-location-map>
      </div>

      <app-similar-properties
        [purpose]="(unitData?.purpose === 'rent' || unitData?.purpose === 'sale_and_rent') ? 'rent' : 'sale'"
        [excludeId]="offerTargetId">
      </app-similar-properties>

    </div>

    <div class="lg:col-span-1">
      <app-sidebar [propertyData]="propertyData" [targetType]="offerTargetType" [targetId]="offerTargetId"
        [salePriceId]="offerSalePriceId" [negotiable]="offerNegotiable" [agentInitial]="agentInitial"
        [ownerContact]="ownerContact" [selectedPlanSummary]="propertyData.selected_plan_summary"
        (changePlanRequested)="scrollToPaymentPlans()">
      </app-sidebar>
    </div>

  </div>
  }
</div>
</div>

<app-image-modal [isOpen]="isImageModalOpen" [galleryImages]="galleryImages" [selectedImageIndex]="selectedImageIndex"
  (close)="closeImageModal()" (previousImage)="previousImage()" (nextImage)="nextImage()">
</app-image-modal>